import { useEffect } from 'react'
import { useLocation } from 'react-router'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const targetId = decodeURIComponent(hash.replace('#', ''))
      const scrollToTarget = () => {
        const element = document.getElementById(targetId)
        if (!element) return false
        element.scrollIntoView({ behavior: 'auto', block: 'start' })
        return true
      }

      if (!scrollToTarget()) {
        let attempts = 0
        const maxAttempts = 12
        const interval = window.setInterval(() => {
          attempts += 1
          if (scrollToTarget() || attempts >= maxAttempts) {
            window.clearInterval(interval)
          }
        }, 120)
      }
      return
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
